import ApiClient from './ApiClient';

class VoiceLinesAPI extends ApiClient {
  constructor() {
    super('voice_lines', { accountScoped: true });
  }
}

export default new VoiceLinesAPI();
